<span data-toggle="modal" data-target="#timeshiftmodal" class="material-icons m-0 ml-3 rounded-circle btn portal-icon p-1 w-33 h-33" matTooltip="{{ 'projecttimeshift.timeshift' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
    update
  </span>

<div class="modal fade" id="timeshiftmodal" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <app-loadconfirm *ngIf="showSpinner" [text]="'projecttimeshift.loadconfirmmove' | trans" [icon]="'schedule_send'"></app-loadconfirm>
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projecttimeshift.header' | trans }}</h5>
        <button #closetimeshift type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="exampleFormControlSelect1"><p class="mb-0">{{ 'projecttimeshift.postponeall' | trans }}</p></label>
          <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]='timeShift.duration'>
            <option disabled selected>{{ 'projecttimeshift.selectamount' | trans }}</option>
            <option value="1">1 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="2">2 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="3">3 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="4">4 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="5">5 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="6">6 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="7">7 {{ 'projecttimeshift.days' | trans }}</option>
            <option disabled>{{ 'projecttimeshift.timemachine' | trans }}</option>
            <option value="-1" >-1 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="-2">-2 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="-3">-3 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="-4">-4 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="-5">-5 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="-6">-6 {{ 'projecttimeshift.days' | trans }}</option>
            <option value="-7">-7 {{ 'projecttimeshift.days' | trans }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="exampleFormControlInput1"><p class="mb-0">{{ 'projecttimeshift.postponeall' | trans }}</p></label>
          <input class="form-control" id="exampleFormControlInput1" name = 'myInput' [(ngModel)]='timeShift.duration'  placeholder="{{ 'projecttimeshift.typeamount' | trans }}">
        </div>
        <div *ngIf="consoleErrorToggle" class="alert alert-danger m-0" role="alert">
          {{consoleError}}
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'projecttimeshift.close' | trans }}</p></button>
        <button type="button" class="btn-save" (click) ="shiftTime()"><p class="btn-save-text">{{ 'projecttimeshift.confirmchanges' | trans }}</p></button>
      </div>
    </div>
  </div>
</div>
